import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {AdminHomePage} from "../admin-home/admin-home";
import {AuthAdminService} from "../../services/authAdminService";

@IonicPage()
@Component({
  selector: 'page-admin-login',
  templateUrl: 'admin-login.html',
})
export class AdminLoginPage {

  email: string;
  password: string;

  constructor(public navCtrl: NavController, public navParams: NavParams,
              private auth: AuthAdminService) {
  }

  ionViewDidLoad() {
  }

  login(){
    this.auth.login(this.email, this.password)
      .then(() => this.navCtrl.setRoot(AdminHomePage))
      .catch((error) => {
        console.error(error);
        alert('Wrong Password!')
      })
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-login/admin-login.ts